/**
 * How a configured phone number is carried. primary owns this vocabulary — its phone number
 * configuration record stores the type, and its
 * `/flow/data-access/phone-number-configurations/:id` endpoint returns it.
 */
export var PhoneNumberType;
(function (PhoneNumberType) {
    PhoneNumberType["Pstn"] = "Pstn";
    PhoneNumberType["Sip"] = "Sip";
})(PhoneNumberType || (PhoneNumberType = {}));
//# sourceMappingURL=phoneNumberType.js.map